import { render } from "./Avatar.vue?vue&type=template&id=34f0dfbe&scoped=true"
import script from "./Avatar.vue?vue&type=script&lang=ts"
export * from "./Avatar.vue?vue&type=script&lang=ts"

import "./Avatar.vue?vue&type=style&index=0&id=34f0dfbe&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-34f0dfbe"

export default script